"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactLabel = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var styles = _interopRequireWildcard(require("./styles.module.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонент для выстраивания набора лейблов в Контакте
 * Ожидается использование непосредственно в ContactLabels
 */
const ContactLabel = /*#__PURE__*/React.forwardRef(function Label(_ref, ref) {
  let {
    icon,
    title,
    href,
    target,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: styles['label']
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: styles['icon']
  }, icon), href ? /*#__PURE__*/React.createElement("a", {
    className: (0, _clsx.default)(styles['title'], styles['clickable']),
    href: href,
    target: target,
    onClick: onClick
  }, title) : /*#__PURE__*/React.createElement("span", {
    className: (0, _clsx.default)(styles['title'], onClick && styles['clickable']),
    onClick: onClick
  }, title));
});
exports.ContactLabel = ContactLabel;